/* =========================================================
   QuenchSea — Shared section behaviour
   Load once via {{ 'qs-sections.js' | asset_url | script_tag }}
   ========================================================= */

(function () {
  "use strict";

  // 🔒 Prevent this script from initializing more than once,
  // even if multiple sections include the same script_tag.
  if (window.__qsSectionsInitialized) return;
  window.__qsSectionsInitialized = true;

  /* ---------- Sticky header shadow on scroll ---------- */
  function initHeader() {
    var header = document.querySelector("[data-qs-header]");
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 12) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav toggle ---------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-qs-mobile-toggle]");
    var menu = document.querySelector("[data-qs-mobile-nav]");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      menu.classList.toggle("is-open");
    });
  }

  /* ---------- Technology image gallery (prev/next + dots) ---------- */
  function initTechGallery() {
    document.querySelectorAll("[data-qs-gallery]").forEach(function (gallery) {
      var img = gallery.querySelector("[data-qs-gallery-img]");
      var dots = gallery.querySelectorAll("[data-qs-gallery-dot]");
      var prevBtn = gallery.querySelector("[data-qs-gallery-prev]");
      var nextBtn = gallery.querySelector("[data-qs-gallery-next]");
      if (!img || !dots.length) return;

      var shots = [];
      dots.forEach(function (dot) {
        shots.push(dot.getAttribute("data-src"));
      });

      var index = 0;

      function render() {
        img.style.opacity = "0";
        setTimeout(function () {
          img.src = shots[index];
          img.style.opacity = "1";
        }, 120);
        dots.forEach(function (dot, i) {
          dot.classList.toggle("is-active", i === index);
        });
      }

      function go(newIndex) {
        var n = shots.length;
        index = (newIndex + n) % n;
        render();
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          go(i);
        });
      });
      if (prevBtn) prevBtn.addEventListener("click", function () { go(index - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { go(index + 1); });
    });
  }

  /* ---------- Add to cart (real Shopify AJAX cart) ---------- */
  function initCart() {
    var countEls = document.querySelectorAll("[data-qs-cart-count]");

    function updateCartCount() {
      fetch("/cart.js")
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function (err) {
          console.error("QuenchSea cart count fetch failed", err);
        });
    }

    // ✅ Only bind buttons that haven't already been bound
    // (extra safety net even if init runs more than once,
    // e.g. after a Shopify theme-editor section re-render)
    document
      .querySelectorAll("[data-qs-add-to-cart]:not([data-qs-bound])")
      .forEach(function (btn) {
        btn.setAttribute("data-qs-bound", "true");

        // Save original button HTML so we can restore it if something fails
        var originalHTML = btn.innerHTML;

        btn.addEventListener("click", function (e) {
          e.preventDefault();

          // Prevent double-clicks while already processing
          if (btn.disabled) return;

          var variantId = btn.getAttribute("data-variant-id");

          if (!variantId) {
            console.warn("QuenchSea: this button has no linked product/variant, so it can't be added to cart.");
            return;
          }

          // 🔄 Show loading state
          btn.disabled = true;
          btn.classList.add("is-loading");
          btn.innerHTML = "Adding...";

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error("Add to cart failed");
              return res.json();
            })
            .then(function () {
              btn.innerHTML = "Added ✓";
              updateCartCount();
              document.dispatchEvent(new CustomEvent("qs:cart:added"));
              setTimeout(function () {
                window.location.href = "/cart";
              }, 400); // small delay so user sees the "Added" confirmation
            })
            .catch(function (err) {
              console.error("QuenchSea add to cart failed", err);
              btn.innerHTML = "Try again";
              btn.disabled = false;
              btn.classList.remove("is-loading");
              setTimeout(function () {
                btn.innerHTML = originalHTML;
              }, 1800);
            });
        });
      });

    // Show correct count on page load
    updateCartCount();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initMobileNav();
    initTechGallery();
    initCart();
  });
})();

